<template>
    <div
      class="mt-0">
      <v-layout wrap>
        <v-flex>
  
          <section>
            <v-card 
              flat
              class="ma-4 mt-0 box-shadow pb-5"
              style="border-radius: 10px;">
  
              <v-row
                class="pa-4 py-0">
                <v-col
                  cols="12"
                  md="7"
                  class="pb-0">
                  <span
                    class="fs-16 black--text ml-2 mb-3"
                    style="font-weight: 600;">
                    Strata Harga
                  </span>
                </v-col>
              </v-row>
  
              <v-card 
                flat
                class="mt-5 mx-5"
                style="border-radius: 6px; border: 1px solid #E7E7E7;">
                <div class="view">
                  <div v-if="!process.load" :class="process.load || list.length === 0 ? '' : 'wrapper'">
                    <table style="border-radius: 6px; width: 100%;" class="table" v-if="tabs === 1">
                      <tr>
                        <th style="width: 1px; white-space: nowrap; font-size: 12px !important; border: 1px solid #ededed; border-left: none; border-top: none; padding: 8px 12px; text-align: left;">
                          Nama Strata
                        </th>
                        <th @click="sortBy !== 'min' ? toSort('min') : toDesc();" style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; border-top: none; padding: 8px 12px; text-align: left;">
                          Qty Minimum
                          <span v-if="sortBy === 'min'">
                            <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>
                        <th @click="sortBy !== 'max' ? toSort('max') : toDesc();" style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; border-top: none; padding: 8px 12px; text-align: left;">
                          Qty Maksimum
                          <span v-if="sortBy === 'max'">
                            <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>
                        <th @click="sortBy !== 'nominal' ? toSort('nominal') : toDesc();" style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; border-top: none; padding: 8px 12px; text-align: left;">
                          Nominal
                          <span v-if="sortBy === 'nominal'">
                            <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>
                        <th @click="sortBy !== 'quota' ? toSort('quota') : toDesc();" style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; border-top: none; padding: 8px 12px; text-align: left;">
                          Kuota
                          <span v-if="sortBy === 'quota'">
                            <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>
                        <th @click="sortBy !== 'quota_used' ? toSort('quota_used') : toDesc();" style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; border-top: none; padding: 8px 12px; text-align: left;">
                          Kuota Terpakai
                          <span v-if="sortBy === 'quota_used'">
                            <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>
                      </tr>
                      <tr v-for="(item, index) in list" :key="index" @click="selected.row = index" :class="selected.row === index ? 'selected' : ''">
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                          <a
                            class="text-decoration-none"
                            target="_blank"
                            :href="`/strata-harga/detail/${item.price_strata_id}`">
                            {{ item.price_strata_name }}
                          </a>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">{{ item.min | number }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">{{ item.max | number }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">{{ (item.nominal*1) | price }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">{{ item.quota | number }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">{{ item.quota_used | number }}</td>
                      </tr>
                    </table>
                  </div>
  
                  <v-card-text
                    v-if="process.load" 
                    class="pb-0 my-4" 
                    style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-4 title">
                        Mohon Tunggu . . .
                      </div>
  
                      <v-progress-linear
                        :color="set_color"
                        indeterminate
                        rounded
                        height="10">
                      </v-progress-linear>
                    </div>
                  </v-card-text>
  
                  <v-card-text
                    v-if="list.length === 0"
                    class="pb-0 my-4" style="height: calc( 100vh - 350px ); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <v-img 
                        class="mx-auto"
                        contain
                        alt="vuetify"
                        :width="90"
                        :height="90"
                        :src="require('@/assets/image/empty.png')">
                      </v-img>
                      <div class="mt-3 fs-16">
                        Belum Ada Data
                      </div>
                    </div>
                  </v-card-text>

                </div>
              </v-card>
            </v-card>
  
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { TokenService } from "@/service/Storage.Service";
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      props: {
        detailCustomer: {
          type: Object,
          default: {}
        }
      },
      data () {
        return {
          checkbox: false,
          tabs: 1,
          tab: [
            {
              title: 'Data Stara Harga'
            },
            {
              title: 'Data Toko Promo'
            },
          ],
  
          dialog: {
            fullscreen: false,
            snackbar: false,
            freeze: false,
            hide: false,
  
            filter: false,
  
            form: false,
            delete: false
          },
          
          search: '',
  
          filter: {
            year: new Date().getFullYear()
          },
          sortBy: 'id',
          sortDesc: '-',
  
          selected: {
            freeze: [],
            delete: [],
            row: []
          },
  
          sales: [],
  
          form: {
            id: '',
            sales_id: '',
            name_alias: '',
            name: '',
            mobilephone: '',
            address: '',
            pic_name: '',
            email: '',
            nik: '',
            npwp: '',
            plafon: '',
            faktur: '',
            term: '',
            ttd: ''
          },
  
          options: {},
          headers: [],
          list: [],
          pagination: {},
          paginationList: {
            page: 1,
            row: 50
          },
  
          lastIndex: 0,
          limit: 50,
  
          process: {
            load: false,
  
            delete: false
          },
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {
        pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination_other.vue'),
      },
      watch: {
      },
      computed: {
        rps () {
          return this.$vuetify.breakpoint.name
        },
        user () {
          return this.$store.state.user
        },
        fcm () {
          return this.$store.state.fcm
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        },
  
        configHeaders () {
          return this.headers.filter(header => !header.hide)  
        },
  
        years () {
          let max = new Date().getFullYear()+2, min = max - 2, years = []
  
          for (let i = max; i >= min; i--) {
            years.push({
              text: i,
              value: i
            })
          }
  
          return years
        }
      },
      mounted () {
        this.fetchPromo()
      },
      methods: {
  
        async fetchPromo (pagination = { row: 50, page: 1 }) {
          this.process.load = true
  
          let params = {
            // is_delivery: '0',
            limit: 100000000,
            customer_id: this.$route.params.id,
            sort: `-id`,
            // sort: this.options.sortBy.length < 1 ? 'id' : this.options.sortDesc[0] ? `-${this.options.sortBy[0]}` : this.options.sortBy[0],
            // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
            search: this.search,
            // unit_id: this.$store.state.user.unit_id === '0' || this.$store.state.user.unit_id === 0 ? '' : this.$store.state.user.unit_id
          }
  
          this.selected.row = []
  
          // admin/services/data
          
          await get(`admin/strata_price/strata_price_store`, { params })
          .then(response => {
            let res = response.data
            
            this.process.load = false
            
            this.list = []
            this.pagination = {}
            
            if (res.status === 200) {
      
              this.list = res.results.data
              this.pagination = res.results.pagination
            }
          })
        },
      }
    }
  </script>
  
  <style>
    ::-webkit-scrollbar-thumb{
      border-radius: 10px;
      background-color: #718EBF;
    }
    table, th, td {
    border-spacing: 4px;
    border-collapse: collapse;
  }
  
  .view {
    margin: auto;
    /* width: 100%; */
  }
  
  .wrapper { 
    overflow-y: auto; 
    height: calc(100vh - 300px); 
  } 
  
  .wrapper-none { 
    /* overflow-y: auto; 
    height: calc(100vh - 270px);  */
  } 
  
  .wrapper th { 
    position: sticky; 
    top: 0; 
    background-color: white !important;
  } 
  .sticky-col {
    position: -webkit-sticky;
    position: sticky;
    background-color: white !important;
  }
  
  .one-col {
    width: 60px;
    min-width: 60px;
    max-width: 60px;
    left: 0px;
  }
  
  .second-col {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    left: 150px;
  }
  
  .three-col {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    left: 300px;
  }
  
  .four-col {
    width: 200px;
    min-width: 200px;
    max-width: 200px;
    left: 450px;
  }
  
  tr:hover {background-color: #1976d236;}
  tr.selected {background-color: #1976d236;}
  </style>